import { TextField } from '@mui/material';

export const InputField = ({ label, onChange, type = 'text' }) => {
    return <TextField label={label} variant="filled" onChange={onChange} type={type} />;
};
